@if (filteredStructures$ | async; as structures) {
<mat-form-field [formGroup]="parent" class="form-field" [ngStyle]="formFieldStyles()">
    <mat-label>{{ label() }}</mat-label>
    <input #input type="text" [name]="name" [attr.data-tfa]="label()" matInput [formControlName]="name" [matAutocomplete]="auto" />
    @if (input.value && parent.get(name)?.enabled) {
    <mat-icon matSuffix [attr.data-tfa]="'empty-input-icon_' + label()" (click)="reset($event)" class="cursor-pointer">close</mat-icon>
    } @if (parent.get(name)?.errors) {
    <mat-error>
        @if (parent.get(name)?.errors?.vide) {
        {{ parent.get(name)?.errors?.vide }}
        } @if (parent.get(name)?.errors?.structureInexistante) {
        {{ parent.get(name)?.errors?.structureInexistante }}
        }
    </mat-error>
    }
</mat-form-field>
<mat-autocomplete
    #auto="matAutocomplete"
    data-tfa="autoComplete"
    role="combobox"
    aria-expanded="false"
    aria-controls="idOptionStructures"
    [panelWidth]="500"
    [displayWith]="getFullValue(structures)"
>
    @for (n of structures; track n) {
    <mat-option [value]="n[keyOfStructureToSave()]" [attr.data-tfa]="'structures_option-' + n[keyOfStructureToSave()]">
        <span> {{ n[keyOfStructureToSave()] }} : {{ n.libelle }} </span>
    </mat-option>
    }
</mat-autocomplete>
}
